import type { PanelImperativeHandle, PanelSize } from 'react-resizable-panels'

/**
 * Expands the panel to its most recent size (or defaultSize on first expand).
 */
export const expand = (panel: PanelImperativeHandle) => {
  if (panel.isCollapsed()) {
    panel.expand()
  }
}

/**
 * Collapses the panel to its collapsedSize.
 */
export const collapse = (panel: PanelImperativeHandle) => {
  if (!panel.isCollapsed()) {
    panel.collapse()
  }
}

/**
 * Creates an onResize handler that fires onCollapse at 0px and onExpand otherwise.
 * Replaces the v2 onCollapse/onExpand props removed in v4.
 */
export const onCollapseExpand =
  (onCollapse: () => void, onExpand?: () => void) => (size: PanelSize) => {
    if (size.inPixels === 0) {
      onCollapse()
    } else {
      onExpand?.()
    }
  }
